export const MetricsAggregatorABI = [
	{
		inputs: [
			{
				internalType: "address",
				name: "_nodeManager",
				type: "address",
			},
			{
				internalType: "address",
				name: "_nodeController",
				type: "address",
			},
			{
				internalType: "address",
				name: "_nodeController2",
				type: "address",
			},
			{
				internalType: "address",
				name: "_nodeController3",
				type: "address",
			},
		],
		stateMutability: "nonpayable",
		type: "constructor",
	},
	{
		inputs: [],
		name: "totalNodesCreated",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256",
			},
		],
		stateMutability: "view",
		type: "function",
	},
] as const;

export default MetricsAggregatorABI;
